const fr_FR = {
  restartInterviewButton: "Recommencer",
  restartInterviewConfirmTitle: "Commencer un nouvel entretien ?",
  restartInterviewConfirmDescription: "Un nouvel entretien commencera depuis le début. Les données de vos entretiens précédents seront conservées.",
  restartInterviewCancel: "Annuler",
  restartInterviewFailed: "Impossible de recommencer l’entretien. Veuillez réessayer plus tard.",
  restartInterviewLimitReached: "La limite d’entretiens est atteinte. Vous ne pouvez pas en commencer un nouveau.",
  restartInterviewClosed: "Cet entretien est fermé. Vous ne pouvez pas en commencer un nouveau.",
  restartInterviewCutoff: "La date limite de l’entretien est passée. Vous ne pouvez pas en commencer un nouveau.",
  interviewLoading: "Chargement de l’entretien…",
  interviewLinkInvalid: "Lien d’entretien non valide",
  interviewLoadFailed: "Impossible de charger l’entretien. Veuillez réessayer plus tard.",
  interviewRetry: "Réessayer",
  interviewProgressSaved: "La progression de l'entretien ne sera pas perdue",
  saveInfoFailed: "Impossible d'enregistrer vos informations. Veuillez réessayer.",
  loadLatestInterviewFailed: "Impossible de charger le dernier enregistrement de l'entretien. Veuillez réessayer plus tard.",
  previousStimulus: 'Concept précédent',
  nextStimulus: 'Concept suivant',
  expandStimulus: 'Agrandir le concept',
  closeStimulusPreview: "Fermer l'aperçu du concept",
  stimulusPreview: 'Aperçu du concept',
  imageTooLarge: "L'image ne doit pas dépasser 10 Mo",
  imageFormatJpegPngOnly: 'Seules les images PNG, JPEG et JPG sont acceptées',
  imageFilesOnly: 'Seuls les fichiers image peuvent être téléversés',
  imageUploadFailed: "Impossible de téléverser l'image. Veuillez réessayer.",
  finalUploadFailed: 'Impossible de téléverser les fichiers. Veuillez réessayer.',
  Welcome: "Bienvenue a l'entretien pour",
  StartInterview: "Commencer l'entretien",
  Submit: 'Soumettre',
  Stoprecording: "Arreter l'enregistrement",
  Aiinterviewer: 'INTERVIEWEUR IA',
  AiModeratedInterview: 'ENTRETIEN MODÉRÉ PAR IA',
  TalkToAva: 'Parler à Ava',
  microphoneAccessTitle: "Autoriser l'accès au microphone",
  microphoneAccessDescription: 'Ava a besoin de votre microphone pour une conversation vocale naturelle.',
  microphoneAllow: 'Autoriser le microphone',
  microphoneNotNow: 'Pas maintenant',
  microphoneConnectedTitle: 'Microphone connecté',
  microphoneConnectedDescription: 'Tout est prêt. Ava est prête à vous écouter.',
  microphoneDeniedTitle: "L'accès au microphone est nécessaire",
  microphoneDeniedDescription: "Autorisez le microphone dans les réglages du navigateur, puis réessayez.",
  microphoneTryAgain: 'Réessayer',
  VoiceAnswer: 'Reponse vocale',
  TextAnswer: 'Reponse texte',
  StudyMainTitle:
    "Avant l'entretien proprement dit, nous allons faire une preselection",
  StudyMainTip:
    "Malheureusement, vous ne faites pas partie du groupe cible de cet entretien et ne pouvez pas y participer",
  TitleTop: 'VOUS ETES INVITE !',
  HeardVoice: 'FAITES ENTENDRE VOTRE VOIX AVEC RECOMPENSE',
  Sophie: 'Discussion decontractee de 5 a 10 min avec Ava',
  Sponsored: 'Sponsored by Santa Clause🎅',
  Chikkens: 'Lancez une discussion rapide et obtenez une recompense',
  Dollars: 'avec votre CHIMOJI unique',
  Congrats: 'FELICITATIONS !',
  ThankYou: 'Merci pour vos retours',
  Identity: 'Choisissez votre identite',
  Refresh: 'Actualiser la page ne fera pas perdre la progression de ce chat',
  Carousel:
    'Une legere latence peut survenir en raison des conditions du reseau',
  CheckOut: 'Vous voulez creer des entretiens comme celui-ci ? Decouvrez ',
  Rewarded:
    "Si vous souhaitez etre recompense, l'intervieweur a besoin d'informations sur vous ",
  InterviewerReward: "Voici la recompense de votre intervieweur ",
  Register: "S'inscrire/se connecter en tant que",
  Insighteer: 'INSIGHTEER',
  Reward: 'pour obtenir votre recompense',
  CreatePassword:
    'en creant votre mot de passe pour terminer votre inscription',
  Becoming: 'Devenir',
  Password: 'Veuillez saisir votre mot de passe !',
  ChooseTopic: 'Choisissez un sujet qui vous interesse',
  Awesome: 'Genial !',
  Rocks: 'SUPER',
  Followus: 'Suivez-nous',
  Unique:
    'Ce CHIMOJI unique est cree a partir de cette conversation sous forme de NFT sur la blockchain',
  Next: 'SUIVANT',
  ViewRewards: 'VOIR LES RECOMPENSES',
  endMeg1:
    'Veuillez laisser votre e-mail ici pour que nous puissions vous envoyer la lecture vocale',
  endMeg2:
    "Veuillez laisser vos informations ici pour recevoir des avantages du createur de cet entretien",
  endMeg3:
    'Veuillez laisser vos informations ici pour le createur de cet entretien',
  endMsg5: 'Veuillez laisser vos informations ici pour obtenir le ',
  endMsg6: 'resultat de votre test MBTI',
  Done: 'TERMINER',
  Done1: 'TERMINER',
  GetIncentives: 'OBTENIR DES AVANTAGES',
  GetStartedFreeNow: 'Commencez gratuitement maintenant',
  UniqueChimojiNFT: 'Chimoji NFT unique',
  endMsg4: 'Vous voulez creer votre propre entretien ?',
  ResumeInterview: "Cliquer pour reprendre l'entretien",
  interviewPausedTitle: 'Entretien en pause',
  interviewPausedDescription: 'Votre progression a été enregistrée. Vous pourrez reprendre quand vous serez prêt.',
  resumeInterviewButton: "Reprendre l'entretien",
  pauseInterview: 'Mettre en pause',
  pauseInterviewConfirmTitle: "Mettre l'entretien en pause ?",
  pauseInterviewConfirmContent:
    'Votre progression sera enregistrée. Vous pourrez reprendre l’entretien plus tard.',
  pauseInterviewConfirmOk: 'Mettre en pause',
  pauseInterviewConfirmCancel: "Continuer l'entretien",
  poorConnection: 'Connexion faible',
  connectionReconnectingTitle: 'Reconnexion en cours…',
  connectionReconnectingDescription: 'Gardez cette page ouverte. Ava rétablit la connexion.',
  connectionReconnectedTitle: 'Reconnecté',
  connectionReconnectedDescription: "La connexion est rétablie. L'entretien reprend.",
  connectionDisconnectedTitle: 'Connexion perdue',
  connectionDisconnectedDescription: "Votre progression dans l'entretien a été enregistrée.",
  refresh: "Actualiser la page ne fera pas perdre la progression",
  voiceSnapshot: 'Instantane vocal',
  fromInterview: "De mon entretien avec Ava, curatrice d'histoires IA",
  findMore: 'En savoir plus sur Chikka.ai',
  msg1: 'TESTEZ VOTRE MBTI EN 5 MIN EN PARLANT AVEC AVA',
  speaking: 'Vous parlez...',
  avaSpeaking: 'Ava parle...',
  avaListening: 'Ava ecoute...',
  stimuliConversationWithAva: 'Vous etes en conversation avec Ava',
  stimuliReviewConcepts:
    'Veuillez examiner attentivement les concepts ci-dessous et repondre aux questions d Ava.',
  stimuliSwipeInstruction:
    'Glissez vers la gauche ou la droite pour voir tous les concepts.',
  stimuliFullscreenInstruction: 'Double-cliquez sur une image pour l afficher en plein ecran.',
  finalUploadTitleFallback: 'Televerser des fichiers',
  finalUploadInstructionFallback:
    'Ajoutez des fichiers avant de terminer l entretien',
  finalUploadTap: 'Touchez pour televerser',
  finalUploadHelp:
    'Votre fichier nous aide a mieux comprendre votre experience.',
  finalUploadLimit: 'Maximum 10 fichiers',
  finalUploadSubmit: 'ENVOYER',
  finalUploadSkip: 'Ignorer',
  finalUploadWait:
    'Veuillez attendre la fin du televersement de tous les fichiers',
}

export default fr_FR
